<div class="img-container" [routerLink]="urls.snip(snip)">
    <media-image [media]="snip.track" default="album"></media-image>
    <playback-control-button (play)="play()" (pause)="pause()" [playing]="playing()" *ngIf="!disablePlayback"></playback-control-button>
</div>
<div class="footer">
    <a class="track-name primary-text" [routerLink]="urls.snip(snip)">{{snip.track.name}}</a>
    <!-- <artists-links-list class="artist-name secondary-text" [artists]="album.artists"></artists-links-list> -->
</div>
